export default __webpack_public_path__ + "static/media/feather-icon - eye-off.e498e58d.svg";